import { UtilisationCardIcon } from "../../../common/icons/resourcesUtilisation/UtilisationCardIcon";

const ResourceAvailabilityHeader = () => {
  return (
    <header
      className="d-flex amd-container-vcolumn pb-sm-2"
      data-testid="resource-availability-header"
    >
      <div className="d-flex">
        <div className="d-flex amd-container-vcolumn">
          <UtilisationCardIcon />
          <div className="fs-14 fw-500">Resources Availability</div>
        </div>
      </div>
    </header>
  );
};

export default ResourceAvailabilityHeader;
